import { useReducer, Dispatch } from "react"
import { createContainer } from "unstated-next"
import { state } from "./state"
import deepmerge from "deepmerge"

type Reducer = [State, Dispatch<Partial<State>>]

function useReducerContainer(initialState: State = state) {
  return useReducer(reducer, initialState)
}

function reducer(prev: State, state: Partial<State>): State {
  // FIXME: estudar mais o caso de propriedades undefined,
  // quando vc não deseja modificar o dado
  const clean = removeUndefined(state)
  return deepmerge(prev, clean)
}

function removeUndefined(data: unknown) {
  return JSON.parse(JSON.stringify(data))
}

export const Container = createContainer<Reducer, State>(useReducerContainer)
export const useContainer = Container.useContainer
